import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  viewMore: {
    defaultMessage: 'View More',
    description: 'Button to expand truncated text to show full message',
    id: 'b4YITy',
  },
  viewLess: {
    defaultMessage: 'View Less',
    description: 'Text for a button to collapse full text to a short, truncated message',
    id: 'Bt+AlB',
  },
});
